import { isValidElement } from 'react';
import ReactDOMServer from 'react-dom/server';
export const reactNodeToString = (node) => {
    if (typeof node === 'string' || typeof node === 'number') {
        return String(node);
    }
    if (isValidElement(node)) {
        // For React elements, return only the text content, not the full HTML markup
        const htmlString = ReactDOMServer.renderToStaticMarkup(node);
        // Remove HTML tags using regex, leaving only the text content
        return htmlString.replace(/<[^>]*>/g, '');
    }
    return '';
};
export const formatValue = (value, primaryFormatter, fallbackFormatter) => {
    if (primaryFormatter) {
        return reactNodeToString(primaryFormatter(value));
    }
    if (fallbackFormatter) {
        return reactNodeToString(fallbackFormatter(value));
    }
    return String(value);
};
